import { StepCoreBase } from "./step.core.base"


export class StepCore extends StepCoreBase {

}